import {
  createUnleashPlugin,
  initUnleashClients,
  updateUnleashContext
} from "./unleash";

// Create the Unleash plugin
const UnleashPlugin = createUnleashPlugin();

// Function to initialize Unleash and install the plugin
export const initUnleashFeatureFlags = async (Vue) => {
  if (
    !process.env.VUE_APP_FCS_OPENFEATURE_URL ||
    !process.env.VUE_APP_FCS_OPENFEATURE_CLIENT_KEY ||
    !process.env.VUE_APP_FCS_OPENFEATURE_APP_NAME
  ) {
    console.warn("Unleash environment variables are not set. Skipping Unleash initialization.");
    return;
  }
  try {
    // Install the plugin
    Vue.use(UnleashPlugin);

    // Initialize the clients
    await initUnleashClients();

    // Example: Set up context for targeting rules
    // You can call this function later with user info
    updateUnleashContext({
      environment: process.env.VUE_APP_ENVIRONMENTS || "development"
      // Add any other context properties needed for targeting
    });
  } catch (error) {
    console.error("Failed to initialize Unleash:", error);
    return;
  }
};

export { FcsFlag, BcsFlag } from "./unleash";
